import { ConfirmModal } from '@crm/components'
import { useState } from 'react'

import { ActionsType } from './types'

export const DeleteOffer = ({ onSuccess, onCancel, ...props }: ActionsType) => {
  const [loading, setLoading] = useState(false)

  const onDelete = () => {
    setLoading(true)
    // Demo: Simulate API call
    setTimeout(() => {
      setLoading(false)
      onSuccess?.()
      onCancel?.()
    }, 500)
  }

  return (
    <ConfirmModal
      loading={loading}
      onSuccess={onDelete}
      onCancel={onCancel}
      {...props}
    />
  )
}
